<template>
  <div id="lista-formulario-card">
    <div
      v-if="tipoDespesa"
      class="lista-formulario-card-numero"
    >
      {{ entradaId }}
    </div>
    <div :style="tipoDespesa ? '' : 'border-radius: 6px'" class="lista-formulario-card-form">
      <div class="box-card-formulario">
        <span class="label-card-formulario"> {{ lista[0].titulo }}</span>
        <span class="value-card-formulario">{{ lista[0].valor }}</span>
      </div>
      <div>
        <div class="box-card-formulario" v-for="(item, i) in lista.slice(1, slice)" :key="i">
          <span class="label-card-formulario"> {{ item.titulo }}</span>
          <span class="value-card-formulario">{{item.valor}}</span>
        </div>
          <div v-show="expandido || aberto">
            <span class="label-card-formulario" v-show="despesa.anexos">Arquivos anexos</span>
            <file-download-card v-if="tipoDespesa" :anexos="despesa.anexos"></file-download-card>
          </div>
        </div>
    </div>
    <div
      v-if="!aberto"
      class="lista-formulario-card-botao"
    >
      <el-link
        :underline="false"
        @click="expandir(!expandido)"
        style="color: #006FB9 !important;"
      >
        <i class="el-icon-arrow-up" v-if="expandido"></i>
        <i class="el-icon-arrow-down" v-else></i>
      </el-link>
    </div>
  </div>
</template>
<script>
import FileDownloadCard from '@/components/cards/FileDownloadCard'
export default {
  name: 'CardDropdown',
  props: {
    despesa: [Object, Array],
    aberto: {
      type: Boolean,
      default: false
    },
    entradaId: {
      type: Number
    },
    tipoDespesa: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      expandido: false,
      lista: [],
      slice: null,
      open: false
    }
  },
  components: {
    FileDownloadCard
  },
  methods: {
    init () {
      if (this.tipoDespesa) {
        this.lista = [{ titulo: 'Data da despesa', valor: this.despesa.data }, { titulo: 'CPF/CNPJ', valor: this.cpfCnpj }, { titulo: 'Valor apresentado', valor: this.valorFormat(this.despesa.valorApresentado) }, { titulo: 'Valor da despesa', valor: this.valorFormat(this.despesa.valorGlosado || 0) }, { titulo: 'Valor a ser reembolsado', valor: this.valorFormat(this.despesa.valorReembolso || 0) }, { titulo: 'Situação', valor: this.despesa.situacao.descricao }]
      } else {
        this.lista = this.despesa
      }
      if (this.aberto) {
        this.slice = this.lista.length
      }
    },
    expandir (abrir) {
      this.expandido = !!abrir
      if (this.expandido) {
        this.slice = this.lista.length
        this.open = true
      } else {
        this.slice = 1
        this.open = false
      }
    },
    valorFormat (valor) {
      return `R$ ${valor.toFixed(2)}`
    }
  },
  computed: {
    cpfCnpj () {
      let tamanho = this.despesa.cpfCnpjExecutante.split('').length
      let result = this.despesa.cpfCnpjExecutante.replace(/\D/g, '')
      if (tamanho === 11) {
        result = result.replace(/(\d{3})(\d)/, '$1.$2')
        result = result.replace(/(\d{3})(\d)/, '$1.$2')
        result = result.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      }
      if (tamanho === 14) {
        result = result.replace(/^(\d{2})(\d)/, '$1.$2')
        result = result.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        result = result.replace(/\.(\d{3})(\d)/, '.$1/$2')
        result = result.replace(/(\d{4})(\d)/, '$1-$2')
      }
      return result
    }
  },
  async created () {
    await this.init()
  }
}
</script>
<style lang="less">
#lista-formulario-card {
  .label-card-formulario {
    font-size: 11px;
    text-align: left;
    color: #333333;
    font-family: "Open Sans", SansSerif;
    display: block;
  }

  .value-card-formulario {
    font-size: 14px;
    text-align: left;
    color: #333333;
    line-height: 19px;
  }

  .box-card-formulario {
    padding-bottom: 10px;
    border-radius: 6px;
  }
  .lista-formulario-card-form {
    border-radius: 0 6px 6px 0;
  }
  .card-download {
    border-radius: 8px;
    box-shadow: none;
    border: none;
    margin-top: 10px;
  }
  .btn-card-downnload {
    float: right;
    color: #006FB9;
  }
  .card-download-title {
    font-family: 'Open Sans', SansSerif;
    font-weight: 600;
  }
  .btn-title {
    vertical-align: top;
    padding-right: 5px;
    font-size: 12px;
    position: relative;
    bottom: 4px;
  }
}
</style>
